import React, { useEffect, useState, useRef } from 'react'
import { Image } from 'react-bootstrap'
import { connect, useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../../conexoes/api'
import '../../../css/painelAdministrativo/pavUsuario/pavUsuario.css'
import {
  desabilitarAcoes,
  limpadorFiltros,
  limpouBusca,
  mudarFiltros,
  mudarManejador,
  realizouBusca,
  realizouFiltro,
  revelarBarraFiltragem,
  revelarExcluirUsuario
} from '../../../redux/actions/index'
import { useGlobal } from '../../../stores/useGlobal.js'
import { elipseVerde, elipseVermelho } from '../../../utils/alternanciaIcones'
import decryptJWT from '../../../utils/decryptJWT'
import BarraFiltragem from '../../componentesModais/barraFiltragem/barraFiltragem'
import MensagemConfirmarExclusao from '../../componentesModais/mensagens/mensagemConfirmarExclusao'
import MensagemErro from '../../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'
import Table from '../../Table/index.jsx'

import CadastrarOuRemoverContaSms from './CadastrarOuRemoverSms/index.jsx'
import CadastroUsuario from './cadastro/cadastro.jsx'

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
const valorLimite = 50

const TableprimaryKey = 'cd_pav_usuario'

function PainelUsuario() {
  const { setFiltros, setRevelarBarraFiltro } = useGlobal()

  const [spinAtivo, setSpinAtivo] = useState(true)
  const [itens, setItens] = useState([])
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(false)

  const [mensagemErro, setMensagemErro] = useState(
    'Ocorreu um erro ao executar esta ação'
  )
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [itensSelecionados, setItensSelecionados] = useState()

  const despacho = useDispatch()
  let conteudoBusca = useSelector((state) => state.manejadorState.conteudoBusca)
  let limpouBuscaGeral = useSelector(
    (state) => state.manejadorState.limpouBusca
  )
  let realizouBuscaGeral = useSelector(
    (state) => state.manejadorState.realizouBusca
  )
  let realizouFiltragem = useSelector(
    (state) => state.manejadorState.realizouFiltro
  )

  let EditarUsuario = useSelector(
    (state) => state.manejadorState.revelarEditarUsuario
  )
  let ExcluirUsuario = useSelector(
    (state) => state.manejadorState.revelarExcluirUsuario
  )
  let revelarAlertaCriarContaSms = useSelector(
    (state) => state.manejadorState.revelarCriarContaSms
  )
  let revelarAlertaRemoverContaSms = useSelector(
    (state) => state.manejadorState.revelarRemoverContaSms
  )

  const itensVarRef = useRef([])
  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  const filtros = useGlobal((state) => state.filtros)
  const revelarBarraFiltro = useGlobal((state) => state.revelarBarraFiltro)

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(120) // 'pavUsuarioTabelaGrid'
      setColetaUsabilidade(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const removeFiltros = () => {
    setFiltros({ vazio: 'vazio' })
    setRevelarBarraFiltro(false)
    despacho(mudarFiltros({ vazio: 'vazio' }))
    despacho(revelarBarraFiltragem(false))
  }

  useEffect(() => {
    if (!filtros.vazio) {
      setFiltros({ vazio: 'vazio' })
      setRevelarBarraFiltro(false)
      despacho(mudarFiltros({ vazio: 'vazio' }))
      despacho(revelarBarraFiltragem(false))
    }
    despacho(limpadorFiltros(true))

    return () => removeFiltros()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setSpinAtivo(true)
    despacho(mudarManejador('usuario'))
    despacho(desabilitarAcoes(true))

    async function carregarTabela() {
      if (limpouBuscaGeral) {
        despacho(limpouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      if (realizouBuscaGeral) {
        despacho(realizouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      if (realizouFiltragem) {
        despacho(realizouFiltro(false))
        restaurarConfigsIniciaisPagina()
      }

      if (conteudoBusca && filtros.vazio) {
        if (totalPaginas == 0) {
          contador = 0
          itensVarRef.current = []
          setItens([])
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          await contarItens()

          const queryString =
            '?paginaAtual=' +
            contador +
            '&carregarLimit=' +
            valorLimite +
            '&buscar=' +
            conteudoBusca +
            '&painel_administrativo=true' +
            '&cd_pav_cliente=' +
            decryptJWT('codigoCliente')

          const { data } = await api_gateway.get(
            '/m1/consultar/usuario' + queryString
          )
          inserirData(data.dados)
        }
      } else if (!filtros.vazio) {
        contador = 0
        itensVarRef.current = []
        setItens([])
        await contarItens()

        contador = (paginaAtual - 1) * valorLimite

        const dados = {
          paguinaAtual: contador,
          carregarLimit: valorLimite,
          buscar: conteudoBusca,
          filtros: filtros,
          cd_pav_cliente: decryptJWT('codigoCliente'),
          painel_administrativo: true
        }

        if (controladorPagina <= paginaAtual) {
          const { data } = await api_gateway.post('/m1/filtrar/usuario', dados)
          inserirData(data.dados)
        }
      } else {
        if (totalPaginas == 0) {
          await contarItens()
        } else {
          contador = (paginaAtual - 1) * valorLimite
        }
        if (controladorPagina <= paginaAtual) {
          const queryString =
            '?paginaAtual=' +
            contador +
            '&carregarLimit=' +
            valorLimite +
            '&painel_administrativo=true' +
            '&cd_pav_cliente=' +
            decryptJWT('codigoCliente')

          const { data } = await api_gateway.get(
            '/m1/consultar/usuario' + queryString
          )

          inserirData(data.dados)
        }
      }
      setSpinAtivo(false)
    }
    carregarTabela()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginaAtual, conteudoBusca, renderizar, filtros])

  function inserirData(data) {
    for (let i = 0; i < totalItens; i++) {
      if (contador === i) {
        let k = i
        for (let j = 0; j < data.length; j++) {
          itensVarRef.current[k] = data[j]
          k++
        }
      }
      if (i == totalItens - 1) {
        setItens(JSON.parse(JSON.stringify(itensVarRef.current)))
      }
    }
  }

  async function contarItens() {
    let arrayItens = []
    let apiData = []
    if (controladorPagina <= paginaAtual) {
      if (controladorPagina <= paginaAtual && filtros.vazio) {
        const queryString =
          '?contar=true' +
          '&buscar=' +
          conteudoBusca +
          '&painel_administrativo=true' +
          '&cd_pav_cliente=' +
          decryptJWT('codigoCliente')

        apiData = await api_gateway.get('/m1/consultar/usuario' + queryString)
      } else {
        const dados = {
          paguinaAtual: contador,
          carregarLimit: valorLimite,
          buscar: conteudoBusca,
          filtros: filtros,
          contar: true,
          cd_pav_cliente: decryptJWT('codigoCliente'),
          painel_administrativo: true
        }
        apiData = await api_gateway.post('/m1/filtrar/usuario', dados)
      }
      itensVarRef.current = []
      if (apiData.data.dados) {
        totalPaginas = Math.ceil(apiData.data.dados[0].CONTADOR / valorLimite)
        totalItens = apiData.data.dados[0].CONTADOR
        for (var i = 0; i < apiData.data.dados[0].CONTADOR; i++) {
          arrayItens.push(i)
        }
        itensVarRef.current = arrayItens
      }
    }
  }

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 0
    setPaginaAtual(1)
  }

  const colunas = [
    {
      dataField: 'cd_pav_usuario',
      text: 'ID',
      sort: true,
      headerClasses: 'tabela-coluna-primeira-header nao-selecionavel',
      formatter: (cell) => (
        <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      )
    },
    {
      dataField: 'ds_nome',
      text: 'Nome',
      sort: true,
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => (
        <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      )
    },
    {
      dataField: 'ds_pav_usuario_sobrenome',
      text: 'Sobrenome',
      sort: true,
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => {
        const trimmedCell = cell?.trim()
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {trimmedCell ? trimmedCell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'ds_email',
      text: 'E-mail / Usuário     ',
      sort: true,
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => (
        <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      )
    },
    {
      dataField: 'ds_telefone',
      text: 'Telefone',
      sort: true,
      formatter: (cell) => (
        <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      )
    },
    {
      dataField: 'cd_pav_pessoa',
      text: 'ID da pessoa',
      hidden: true,
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => (
        <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      )
    },
    {
      dataField: 'cd_pav_perfil',
      text: 'ID do perfil',
      hidden: true,
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => (
        <p className="fonte-cor-1 label-tabela-1">{cell || '-'}</p>
      )
    },
    {
      dataField: 'fl_ativo',
      text: 'Status do usuário',
      sort: true,
      headerClasses: 'tabela-coluna-primeira-header nao-selecionavel',
      formatter: (cell) => {
        if (cell != null) {
          const isActive = cell === 1 || cell === true
          return (
            <p className="fonte-cor-1 label-tabela-1">
              <Image
                className="img-eclipse-status"
                src={isActive ? elipseVerde() : elipseVermelho()}
              />
              {isActive ? 'Ativo' : 'Inativo'}
            </p>
          )
        }
        return ''
      }
    },
    {
      dataField: 'bloqueio_motivo',
      text: 'Motivo da inativação',
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => (
        <p className="fonte-cor-1 label-tabela-1">
          {cell !== 'Sem bloqueio' ? cell : '-'}
        </p>
      )
    },
    {
      dataField: 'userIsSeller',
      text: 'Usuário vendedor',
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => (
        <p className="fonte-cor-1 label-tabela-1">{cell ? 'Sim' : 'Não'}</p>
      )
    },
    {
      dataField: 'smsActive',
      text: 'Conta SMS',
      headerClasses: 'nao-selecionavel',
      formatter: (cell) => (
        <p className="fonte-cor-1 label-tabela-1">
          <Image
            className="img-eclipse-status"
            src={cell ? elipseVerde() : elipseVermelho()}
          />
          {cell ? 'Ativa' : 'Inativa'}
        </p>
      )
    }
  ]

  async function handleDeletar() {
    setSpinAtivo(true)
    await api_gateway
      .get(
        '/m1/deletar/usuario?cd_pav_usuario=' +
          itensSelecionados.cdUsuario +
          '&cd_pav_usuario_deleted=' +
          decryptJWT('codigo')
      )
      .then(function () {
        setSpinAtivo(false)
        handleMensagemSucesso(false)
      })
      .catch(function (error) {
        setSpinAtivo(false)
        setMensagemErro(error.response.data.info)
        handleMensagemErro(false)
      })
  }

  function handleMensagemAtencaoDeletar(confirmacao) {
    let novoValor = true
    if (ExcluirUsuario) {
      novoValor = false
    }
    despacho(revelarExcluirUsuario(novoValor))

    if (confirmacao === true) {
      ColetaClickstream(1375) // dropAcoesRevelarExcluirUsuarioExcluir
      handleDeletar()
    } else {
      ColetaClickstream(1376) // dropAcoesRevelarExcluirUsuarioCancelar
    }
  }

  function handleMensagemErro() {
    if (revelarMensagemErro === false) setRevelarMensagemErro(true)
    else setRevelarMensagemErro(false)
  }

  function handleMensagemSucesso(confirmacao) {
    if (revelarMensagemSucesso === false) setRevelarMensagemSucesso(true)
    else setRevelarMensagemSucesso(false)
    if (confirmacao === true) setRenderizar(!renderizar)
  }

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setItensSelecionados(row)
      despacho(desabilitarAcoes(false))
    }
  }

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  const itensSelecionadosTable = itensSelecionados?.[TableprimaryKey]
    ? [itensSelecionados[TableprimaryKey]]
    : []

  return (
    <>
      <Table
        keyField={TableprimaryKey}
        clickToSelect
        revelarContador
        itens={itens}
        colunas={colunas}
        revelarBarraFiltro={revelarBarraFiltro}
        getTotalItensNaPagina={getTotalItensNaPagina}
        getLimiteNaPagina={getTotalItensNaPagina}
        pagination={{
          paginaAtual,
          valorLimite,
          totalPaginas,
          totalItens,
          contador,
          trocarPagina
        }}
        selection={{
          itensSelecionados: itensSelecionadosTable,
          modeSelection: 'radio',
          handleOnSelect
        }}
      />

      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      {EditarUsuario && (
        <CadastroUsuario
          tituloJanela="Editar"
          usuarioSelecionado={itensSelecionados}
          onFinish={() => setRenderizar(!renderizar)}
        />
      )}
      <BarraFiltragem revelarBarraFiltro={revelarBarraFiltro} />

      {(revelarAlertaCriarContaSms || revelarAlertaRemoverContaSms) && (
        <CadastrarOuRemoverContaSms
          linhaSelecionada={itensSelecionados}
          revelarAlertaRemoverContaSms={revelarAlertaRemoverContaSms}
          revelarAlertaCriarContaSms={revelarAlertaCriarContaSms}
          onFinish={() => setRenderizar(!renderizar)}
        />
      )}

      {revelarMensagemSucesso && (
        <MensagemSucesso
          handleMensagemSucesso={handleMensagemSucesso}
          mensagemTitulo="Sucesso"
          mensagemParagrafo1={
            'Usuário ' + itensSelecionados.ds_pav_usuario + ' deletado.'
          }
          mensagemBotao="Continuar"
        />
      )}
      {ExcluirUsuario && (
        <MensagemConfirmarExclusao
          handleMensagemAtencao={handleMensagemAtencaoDeletar}
          mensagemTitulo={'Deletar ' + itensSelecionados.ds_pav_usuario}
        />
      )}
      {revelarMensagemErro && (
        <MensagemErro
          handleMensagemErro={handleMensagemErro}
          mensagemTitulo={mensagemErro}
          mensagemParagrafo1="Erro"
          mensagemParagrafo2={mensagemErro}
          mensagemBotao="Retornar"
        />
      )}
    </>
  )
}

function mapStateToProps(state) {
  return {
    conteudoBusca: state.manejadorState.conteudoBusca,
    filtros: state.filtrosState.filtros
  }
}
//React.memo - nao permitir a renderizacao se o state e o props nao mudarem de estado
export default connect(mapStateToProps)(React.memo(PainelUsuario))
